<template>
  <div class="entrance-container flex justify-center items-center">
    <!-- 三个入口统一用语义化 <a> 承载跳转：支持键盘 Tab 聚焦、读屏识别为链接、
         右键/中键复制或新开、搜索引擎可抓取；显式标注 target="_blank" 表明新窗口打开；
         rel="noopener noreferrer" 防止新页面通过 window.opener 反向操纵本页 -->
    <a class="item m-r-36" :href="signUpHref" target="_blank" rel="noopener noreferrer">
      <div class="image">
        <el-image style="width: 93px; height: 85px" :src="singUp" />
      </div>
      <div class="font-30 font-weight text-000">网上报名</div>
      <!-- <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">一键报名</div>
           <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">招聘信息</div> -->
    </a>
    <a class="item m-r-36" :href="printHref" target="_blank" rel="noopener noreferrer">
      <div class="image">
        <el-image style="width: 101px; height: 85px" :src="print" />
      </div>
      <div class="font-30 font-weight text-000">准考证打印</div>
      <!-- <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">一键打印</div>
           <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">准考证补打</div> -->
    </a>
    <a class="item" :href="adminHref" target="_blank" rel="noopener noreferrer">
      <div class="image">
        <el-image style="width: 101px; height: 85px" :src="login" />
      </div>
      <div class="font-30 font-weight text-000 ">考务管理</div>
      <!-- <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">查询结果</div>
           <div class="font-22 text-000" style="font-weight: 400;line-height: 55px;">考务管理</div> -->
    </a>
    <!-- 考试列表 -->
    <exam-dialog ref="examDialog" />
  </div>
</template>

<script>
import singUp from "@/assets/image/home/singUp.png";
import print from "@/assets/image/home/print.png";
import login from "@/assets/image/home/login.png";
// cpns
import ExamDialog from "./exam-dialog.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ExamDialog,
  },
  data() {
    return {
      singUp,
      print,
      login,
    };
  },
  computed: {
    // 入口地址统一交给 <a href> 原生跳转（原实现是 div + window.open，无链接语义）。
    // 内部路由用 router.resolve 生成，保证带上前端 base（如 /exam_registration_site_test/）。
    // 网上报名：报名列表页
    signUpHref() {
      return this.$router.resolve({ name: "exam-examlist", query: {} }).href;
    },
    // 准考证打印：工作台「打印准考证」页
    printHref() {
      return this.$router.resolve({ name: "dashboard", query: { index: 2 } })
        .href;
    },
    // 考务管理：管理后台（外部站点）
    adminHref() {
      return "https://gxrcsc.cn/exam_registration_admin/";
    },
  },
  methods: {
    ...mapActions(["fetchExamDataList"]),
  },
};
</script>

<style lang="scss" scoped>
.entrance-container {
  width: 100%;
  box-sizing: border-box;
  padding: 60px 9% 60px;
  background: #f7f7f7;
  box-shadow: 0px 0px 10px 0px #b7b7b7;
  border-radius: 20px;
  border: 1px solid #bfbfbf;

  .item {
    cursor: pointer;
    /* 语义化 <a>：去掉链接默认下划线与链接色，视觉与原 div 保持一致 */
    text-decoration: none;
    color: inherit;
    width: 33%;
    max-width: 350px;
    min-height: 250px;
    padding: 70px 0 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #d8d8d8;
    border-radius: 10px;
    border: 1px solid #bfbfbf;

    /* 键盘 Tab 聚焦时给出可见焦点环（无障碍要求） */
    &:focus-visible {
      outline: 2px solid #1677ff;
      outline-offset: 2px;
    }

    .image {
      -webkit-filter: drop-shadow(0 0 10px rgba(5, 5, 5, 0.2));
      /*考虑浏览器兼容性：兼容 Chrome, Safari, Opera */
      filter: drop-shadow(0 0 10px rgba(5, 5, 5, 0.2));
      margin-bottom: 25px;
    }
  }

  .m-r-36 {
    margin-right: 36px;
  }

  .m-b-50 {
    margin-bottom: 50px;
  }
}

/* 平板端适配 */
@media screen and (max-width: 1024px) {
  .entrance-container {
    padding: 40px 5% 40px;

    .item {
      min-height: 200px;
      padding: 50px 0 60px;

      .font-30 {
        font-size: 22px !important;
      }
    }

    .m-r-36 {
      margin-right: 20px;
    }
  }
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .entrance-container {
    padding: 30px 16px 30px;
    flex-direction: column;
    gap: 20px;

    .item {
      width: 100%;
      max-width: none;
      min-height: 160px;
      padding: 30px 0 40px;

      .font-30 {
        font-size: 20px !important;
      }

      .image .el-image {
        width: 70px !important;
        height: 64px !important;
      }
    }

    .m-r-36 {
      margin-right: 0;
    }
  }
}
</style>
